import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  ChecklistTemplatesListPage,
  ChecklistTemplateCreationPage,
  ChecklistTemplateUpdatePage,
} from 'pages/ChecklistTemplates';

const checklistTemplatesRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/checklist/modelos',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <ChecklistTemplatesListPage />,
    },
    {
      path: 'criar',
      element: <ChecklistTemplateCreationPage />,
    },
    {
      path: ':id/editar',
      element: <ChecklistTemplateUpdatePage />,
    },
  ],
});

export default checklistTemplatesRoutes;
